// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --header-height: 80px;
    --footer-height: 78px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/ClientPortal.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;AACzB","sourcesContent":[":root {\n    --header-height: 80px;\n    --footer-height: 78px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
